<via-header></via-header>
<article>
  <via-loader
    class="loading_overlay"
    [ngClass]="{ show: resolveLoader }"
    [spinnerSize]="200"
  ></via-loader>

  <router-outlet></router-outlet>
</article>
<via-footer></via-footer>
